
import { useState } from 'react';
import { Database } from '@/integrations/supabase/types';

type ClubRow = Database['public']['Tables']['clubs']['Row'];

export const useClubUI = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingClub, setEditingClub] = useState<ClubRow | null>(null);
  const [expandedClubs, setExpandedClubs] = useState<Set<string>>(new Set());
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [clubToDelete, setClubToDelete] = useState<ClubRow | null>(null);

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setEditingClub(null);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
    setClubToDelete(null);
  };

  const toggleClubExpansion = (clubId: string) => {
    const newExpanded = new Set(expandedClubs);
    if (newExpanded.has(clubId)) {
      newExpanded.delete(clubId);
    } else {
      newExpanded.add(clubId);
    }
    setExpandedClubs(newExpanded);
  };

  return {
    isDialogOpen,
    editingClub,
    expandedClubs,
    deleteDialogOpen,
    clubToDelete,
    setIsDialogOpen,
    setEditingClub,
    setDeleteDialogOpen,
    setClubToDelete,
    handleDialogClose,
    handleDeleteDialogClose,
    toggleClubExpansion
  };
};
